import type { ForgetPasswordVerifyOtpRequest, IErrorResponse } from '@/types';

import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { urls } from '@/statics';
import { api } from '@/utils';

const useForgetPasswordVerifyOtp = (): UseMutationResult<
  { token: string },
  IErrorResponse,
  ForgetPasswordVerifyOtpRequest
> => {
  return useMutation({
    mutationFn: (data) => api.post(urls.forgetPasswordVerifyOtp, data),
  });
};

export default useForgetPasswordVerifyOtp;
